import { saveContent } from '@paragon/client-tools';
import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { batch } from '../data/convertCompareCount';
import { prepareFileDataForUpload } from './files';
import { AsyncThunkActionVoid } from './thunkActions';

export const batchFiles =
  (fileData: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Batching files...'));

    const transformedFileData = await prepareFileDataForUpload(fileData);
    const batchResults = await batch(transformedFileData).catch(() => {
      alert('Error Batching.');
      dispatch(removeSpinnerMessage(spinnerId));
    });

    if (batchResults != null) {
      if (batchResults.batchResultsUrl) {
        saveContent('Batch.cnt', batchResults.batchResultsUrl);
      }
    }

    dispatch(removeSpinnerMessage(spinnerId));
  };
